import { Location, CommandResult, FacilityType } from '../amorg-common'
import { apiPath } from "./adminClientApi";
import { commandAuthWrapper, queryAuthWrapper } from "./serverApiHelpers";

const locationsPath = `${apiPath}/locations`;

export const createLocation = async (
    id: string,
    name: string,
    country: string,
    address: string,
    postalCode: string,
    city: string,
    
): Promise<CommandResult> =>
    commandAuthWrapper(`${locationsPath}`, 'POST',
        { id, name, country, address, postalCode, city });

export const updateLocation = async (
    locationId: string,
    name: string,
    country: string,
    address: string,
    postalCode: string,
    city: string,
): Promise<CommandResult> =>
    commandAuthWrapper(`${locationsPath}/${locationId}`, 'PUT',
        { name, country, address, postalCode, city });

export const deleteLocation = async (
    locationId: string
): Promise<CommandResult> =>
    commandAuthWrapper(`${locationsPath}/${locationId}`, 'DELETE');

export const getLocations = async (): Promise<Location[]> =>
{
    const result:Location[] = await queryAuthWrapper(`${locationsPath}`);
    for(const l of result){
        l.created = new Date(l.created);
        for(const f of l.facilities){
            f.created = new Date(f.created);
        }
    }
        
    return result;
}


/* facilities */
export const createFacility = async (
    facilityId: string,
    name: string, 
    building: string, 
    floor: string,
    facilityTypeId:string,
    locationId: string,
): Promise<CommandResult> =>
    commandAuthWrapper(`${locationsPath}/${locationId}/facilities`, 'POST',
        { facilityId, name, building, floor, type:facilityTypeId, locationId });


export const updateFacility = async (
    facilityId: string,
    name: string, 
    building: string, 
    floor: string,
    facilityTypeId:string,
    ownerId: string
): Promise<CommandResult> =>
    {
        return commandAuthWrapper(`${locationsPath}/facilities/${facilityId}`, 'PUT',
        { name, building, floor, type:facilityTypeId, ownerId });}


export const deleteFacility = async (
    facilityId: string
): Promise<CommandResult> =>
    commandAuthWrapper(`${locationsPath}/facilities/${facilityId}`, 'DELETE');

export const getFacilityTypes = async (): Promise<FacilityType[]> =>
{
    const result:FacilityType[] = await queryAuthWrapper(`${locationsPath}/facilitytypes`);  
    return result;
}